import React from 'react';

const galleryImages = [
  'images/gallery-img1.jpg',
  'images/gallery-img2.jpg',
  'images/gallery-img3.jpg',
  'images/gallery-img4.jpg',
  'images/gallery-img5.jpg',
  'images/gallery-img6.jpg',
];

const Gallery = () => {
  return (
    <div className="gallery-main-wrapper float_left">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="page-2-heading">
              <h4 className="text-color">Our Gallery</h4>
            </div>
          </div>
        </div>
      </div>

      <div className="gallery-box-section float_left">
        <div className="container">
          <div className="row">
            {galleryImages.map((img, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12 col-12" key={index}>
                <div className="portfolio_img_wrapper">
                  <div className="portfolio_img">
                    <img
                      src={img}
                      className="img-responsive"
                      alt={`gallery-${index}`}
                    />
                    <div className="portfolio_img_overlay">
                      <div className="portfolio_img_text">
                        <a href={img} title={`image-${index}`} className="img-link">
                          <img src="images/plus-Icon.png" alt="plus-icon" aria-hidden="true" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="col-lg-12 col-md-12 col-12">
              <div className="text-center mt-5">
                <a href="gallery.html" className="page2-btn bg-change">See all Images</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
